import { render, staticRenderFns } from "./SitesList.vue?vue&type=template&id=2d809fd1&scoped=true"
import script from "./SitesList.vue?vue&type=script&lang=js"
export * from "./SitesList.vue?vue&type=script&lang=js"
import style0 from "./SitesList.vue?vue&type=style&index=0&id=2d809fd1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d809fd1",
  null
  
)

export default component.exports